export default __webpack_public_path__ + "static/media/ebikem.c253c456.jpg";